import { render, staticRenderFns } from "./OwalPosterFrameSpinner.vue?vue&type=template&id=4bdf9b43&scoped=true"
import script from "./OwalPosterFrameSpinner.vue?vue&type=script&lang=js"
export * from "./OwalPosterFrameSpinner.vue?vue&type=script&lang=js"
import style0 from "./OwalPosterFrameSpinner.vue?vue&type=style&index=0&id=4bdf9b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf9b43",
  null
  
)

export default component.exports